'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

exports['default'] = _getPrototypeOf;